export default __webpack_public_path__ + "static/media/your-hardWorkNoticed.e121b584.webp";